import debounce from './utils';

jQuery(document).ready(function () {
    const HEADER_HEIGHT = $('.header-nav').outerHeight();
    const SMALL_DEVICE_WIDTH = 601;
    const LARGE_DEVICE_WIDTH = 1200;

    jQuery('.nav-select').change(function () {
        var val = jQuery(this).find('option:selected').val();
        window.location.replace(val);
    });

    var triggerLogicOnScroll = debounce(function () {
        var headerNavWpr = $('.header-nav');
        var largeLogoImg = $('.lg-logo');
        var accLinks = $('.my-account-capitus');
        var searchWpr = $('.has-search');
        var secondaryNavigation = $('header > .container-fluid > .bg-primary') || null;
        var main = $('main');
        var navWpr = $('.col-nav-toggler > div > .navbar-light');
        if (window.pageYOffset >= HEADER_HEIGHT) {

            if (headerNavWpr.hasClass('main-content-wrapper')) {
                headerNavWpr.removeClass('main-content-wrapper position-relative');
                headerNavWpr.addClass('shadow-bottom');
            }
            if (window.outerWidth >= SMALL_DEVICE_WIDTH) {
                searchWpr.hide();
            }
            if (window.outerWidth >= LARGE_DEVICE_WIDTH) {
                accLinks.hide();
                headerNavWpr.removeClass('py-xl-3');
                headerNavWpr.addClass('py-xl-2');
                headerNavWpr.addClass('lg-sticky-header-h');
                largeLogoImg.addClass('rsp-logo mt-1');
                largeLogoImg.removeClass('mx-auto');
            }
            navWpr.removeClass('pt-xl-3');
            navWpr.addClass('pt-xl-2');
            headerNavWpr.addClass('sticky-header');
            if (secondaryNavigation.length != 0) {
                secondaryNavigation.addClass('nav-margin-top');
            } else {
                main.addClass("nav-margin-top");
            }
        } else {

            if (!headerNavWpr.hasClass('main-content-wrapper')) {
                headerNavWpr.addClass('main-content-wrapper position-relative');
                headerNavWpr.removeClass('shadow-bottom');
            }

            if (window.outerWidth >= SMALL_DEVICE_WIDTH) {
                searchWpr.show();
            }

            if (window.outerWidth >= LARGE_DEVICE_WIDTH) {
                accLinks.show();
                largeLogoImg.removeClass('rsp-logo mt-1');
            }

            if (secondaryNavigation.length != 0) {
                secondaryNavigation.removeClass('nav-margin-top');
            } else {
                main.removeClass("nav-margin-top");
            }
            headerNavWpr.addClass('py-xl-3');
            headerNavWpr.removeClass('py-xl-2');
            navWpr.addClass('pt-xl-3');
            navWpr.removeClass('pt-xl-2');
            headerNavWpr.removeClass('lg-sticky-header-h');
            headerNavWpr.removeClass('sticky-header');
            largeLogoImg.addClass('mx-auto');
        }
    }, 250);

    window.addEventListener('scroll', triggerLogicOnScroll);
});